// @flow
import React from 'react';
import { Alert } from '@finect/tabular-components/Alert';
import { PendingModerationBlock } from './partials';

type Props = {
  type: 'question' | 'answer' | 'comment'
};

const TYPES = {
  question: {
    title: '¡Gracias por participar!',
    content: 'Tu pregunta está pendiente de moderación.'
  },
  answer: {
    title: '¡Gracias por participar!',
    content: 'Tu respuesta está pendiente de moderación.'
  },
  comment: {
    title: null,
    content: 'Tu comentario está pendiente de moderación, se mostrará cuando sea aprobado.'
  }
};

export const PendingModerationAlert = ({ type }: Props) => {
  const { title, content } = TYPES[type];

  return (
    <PendingModerationBlock>
      <Alert withIcon={false} type="success" title={title}>
        {content}
      </Alert>
    </PendingModerationBlock>
  );
};
